import { Chat } from "@/components/chat/types";
import { chatService } from "@/services/chatService";

/**
 * Add a new participant to a chat
 */
export const newChatParticipants = async (
  chatId: string,
  userId: string,
  isAdmin?: boolean
): Promise<Chat | null> => {
  try {
    console.log("Adding participant to chat:", chatId, "user:", userId);

    const data = await chatService.addParticipant(chatId, {
      userId,
      role: isAdmin ? 'admin' : 'member',
    });

    return data || null;
  } catch (error) {
    console.error("Failed to add chat participant", error);
    return null;
  }
};
